/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const AssetKeyTenantJsonApiModel = {
  id: "",
  asset: {
    jsonApi: "hasOne",
    type: "assets",
  },
  "asset-id": "",
  "tenant-name": "",
  "created-at": "",
  "updated-at": "",
};
